// Contact Form implementation
class ContactFormHandler {
  constructor(formElement) {
    this.form = formElement;
    this.sendPath = formElement.dataset.sendPath;
    
    // Form data state
    this.contactData = {
      name: '',
      email: '',
      subject: '',
      message: ''
    };
    
    // UI elements
    this.fields = {
      name: this.form.querySelector('[data-contact-field="name"]'),
      email: this.form.querySelector('[data-contact-field="email"]'),
      subject: this.form.querySelector('[data-contact-field="subject"]'),
      message: this.form.querySelector('[data-contact-field="message"]')
    };
    
    this.submitButton = this.form.querySelector('button[type="button"]');
    this.errorMessage = this.form.querySelector('.error-message');
    this.successMessage = this.form.querySelector('.success-message');
    
    this.init();
  }
  
  init() {
    // Bind event listeners
    Object.keys(this.fields).forEach(fieldName => {
      const field = this.fields[fieldName];
      field.addEventListener('input', (e) => this.handleFieldChange(e));
      field.addEventListener('change', (e) => this.handleFieldChange(e));
    });
    
    this.submitButton.addEventListener('click', () => this.sendMessage());
  }
  
  handleFieldChange(e) {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    
    // Update state
    this.contactData[fieldName] = fieldValue;
    
    // Hide messages
    this.hideSuccessMessage();
    
    // Update button state
    this.updateButtonState();
  }
  
  updateButtonState() {
    // Check if all fields have values
    const allFieldsFilled = Object.values(this.contactData).every(value => value.trim() !== '');
    this.submitButton.disabled = !allFieldsFilled;
  }
  
  validateEmail(email) {
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(String(email).toLowerCase());
  }
  
  showError(message) {
    this.errorMessage.textContent = message;
    this.errorMessage.classList.remove('d-none');
  }
  
  hideError() {
    this.errorMessage.classList.add('d-none');
  }
  
  showSuccessMessage() {
    this.successMessage.classList.remove('d-none');
  }
  
  hideSuccessMessage() {
    this.successMessage.classList.add('d-none');
  }
  
  buildSendUrl() {
    const params = Object.entries(this.contactData).map(([key, value]) => {
      const encodedKey = encodeURIComponent(`ticket[${key}]`);
      const encodedValue = encodeURIComponent(value);
      return `${encodedKey}=${encodedValue}`;
    }).join('&');
    
    return `${this.sendPath}.js?${params}`;
  }
  
  resetForm() {
    // Reset state
    this.contactData = {
      name: '',
      email: '',
      subject: '',
      message: ''
    };
    
    // Reset form fields
    Object.values(this.fields).forEach(field => {
      field.value = '';
    });
    
    // Update button state
    this.updateButtonState();
  }
  
  sendMessage() {
    // Validate email
    if (!this.validateEmail(this.contactData.email)) {
      this.showError('Invalid email');
      return;
    }
    
    // Validate message length
    if (this.contactData.message.length < 25) {
      this.showError('The message is too short. 25 characters minimum');
      return;
    }
    
    // Hide error
    this.hideError();
    
    // Send data
    fetch(this.buildSendUrl(), {
      credentials: 'same-origin',
      method: 'post'
    })
    .then(() => {
      // Reset form
      this.resetForm();
      
      // Show success message
      this.showSuccessMessage();
    })
    .catch((error) => {
      console.error('Error sending message:', error);
      this.showError('Failed to send message. Please try again.');
    });
  }
}

// Initialize all contact forms when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const contactForms = document.querySelectorAll('[data-behavior="contactUsForm"]');
  contactForms.forEach(form => {
    new ContactFormHandler(form);
  });
});

// Export for manual initialization if needed
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ContactFormHandler;
}
